import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface ChatErrorNotificationProps {
  error: {
    error: string;
    tool?: string;
  };
}

export const ChatErrorNotification: React.FC<ChatErrorNotificationProps> = ({
  error,
}) => {
  return (
    <div>
      <div className="flex items-start gap-3">
        {/* Warning Icon */}
        <div className="mt-1">
          <ExclamationTriangleIcon className="text-chariot-text-red size-4" />
        </div>

        {/* Error Content */}
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1">
              {error.tool && (
                <div className="text-chariot-text-red text-sm italic">
                  {error.error}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatErrorNotification;
